<template>
  <div class="apply-confirm">
    <div class="status-wrp">
      <img class="invoice-tag" :src="getConfig(detailData).url" v-if="getConfig(detailData).url"/>
    </div>
    <InvoiceDetail v-if="this.$route.query.comeFormDian" :detailData="detailData" :goodsList="goodsList"  :comeFormDian='true' />
    <InvoiceDetail v-else :detailData="detailData" :goodsList="goodsList" />
    <ButtonRow
      v-if="showButton"
      :firstClick="goBack"
      :firstText="renderFirstText()"
      :secondClick="submitApply"
      :secondText="renderBtnText()"
      :bottom="true"
    />

    <!-- <div class="footer">
      <div class="cancel" @click="goBack">取消</div>
      <div class="submit" @click="submitApply">提交申请</div>
    </div> -->
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  Notify
} from 'vant'

import {
  ConvertNumber,
  renderTextWithConfig,
  getDingCode,
  localStorage,
  getConfigWithText
} from '@utils/basicUtil'
import {
  INVOICE_TYPE,
  GET_TYPE,
  INVOICE_STATUS_ICON
} from '@assets/config'

import InvoiceDetail from '@components/InvoiceDetail'
import ButtonRow from '@components/ButtonRow'

import { invoiceRequest, customerRequest } from '@services'

export default {
  data: () => ({
    isClearData: false, // 返回时，是否清空缓存数据
    editId: '',
    showButton: true // 是否展示按钮
  }),
  computed: {
    goodsList () {
      return this.$store.state.invoice.goodsList
    },
    detailData () {
      return this.$store.state.invoice.formData
    },
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  mounted () {
    console.log(this.detailData)
    if (window.location.pathname === '/invoice/applyinfo') { // 有按钮、可点击去修改数据的页面
      this.isClearData = true
    } else if (window.location.pathname === '/invoice/info') { // 不可编辑、不展示按钮、返回要清空数据的页面
      this.isClearData = true
      this.showButton = false
    } else if (window.location.pathname === '/invoice/detail') { // 从开票申请跳过来的
      if (this.$route.query.id) {
        this.editId = this.$route.query.id
      }
    } else if (window.location.pathname === '/invoice/uninvoice/info') { // 电票直开详情
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    renderInvoiceType (text) {
      return renderTextWithConfig(text, INVOICE_TYPE)
    },
    renderGetType (text) {
      return renderTextWithConfig(text, GET_TYPE)
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    submitApply () {
      if (!sessionStorage.detailData) {
        sessionStorage.detailData = JSON.stringify(this.detailData)
      }
      if (window.location.pathname === '/invoice/detail') {
        if (this.detailData.id || this.editId || this.edit) {
          this.modifyApply()
        } else if (this.$route.query.editId) {
          this.modifyApply()
        } else {
          this.saveApply()
        }
      } else if (window.location.pathname === '/invoice/applyinfo' && this.$route.query.btntype === 'edit') {
        this.isClearData = false
        this.$router.push(`/invoice/add-apply?editId=${this.$store.state.invoice.formData.id}&showGoods=1`)
      } else if (window.location.pathname === '/invoice/applyinfo' && this.$route.query.btntype === 'editAndSubmit') {
        this.isClearData = false
        this.$router.push(`/invoice/add-apply?editId=${this.$store.state.invoice.formData.id}&showGoods=1`)
      } else if (window.location.pathname === '/invoice/uninvoice/info') {
        let id = this.detailData.settlementId
        let codeValidTime = this.detailData.lostTime || ''
        this.$router.push(`/invoice/business/show?id=${id}&prescription=${JSON.stringify(codeValidTime)}&infoId=${this.detailData.id}`)
      }
    },
    renderFirstText () {
      if (window.location.pathname === '/invoice/uninvoice/info') {
        return '返 回'
      }
      return '取 消'
    },
    renderBtnText () {
      if (window.location.pathname === '/invoice/detail') {
        if (this.editId.length > 0) {
          return '保存'
        }
        return '提交申请'
      } else if (window.location.pathname === '/invoice/applyinfo') {
        const btntype = this.$route.query.btntype
        if (btntype === 'edit') {
          return '编辑'
        } else if (btntype === 'editAndSubmit') {
          return '修改并重新发起'
        }
        return '重新开具'
      } else if (window.location.pathname === '/invoice/uninvoice/info') {
        return '查看开票码'
      }
    },
    handleApplyData () {
      const postData = {
        ...this.detailData,
        //  files: this.detailData.files.map((file) => file.url),
        fileInfos: this.detailData.files.map((file) => {
          return ({
            fileUrl: file.url,
            fileName: file.file.name
          })
        }),
        files: [],
        invoiceType: Number(this.detailData.invoiceType),
        logisticsFlag: Number(this.detailData.logisticsFlag),
        details: this.goodsList.map(goods => {
          return {
            amountWithTax: goods.amountWithTax,
            goodsName: goods.goodsName,
            quantity: goods.quantity,
            specification: goods.specification,
            taxSign: goods.taxSign,
            unit: goods.unit,
            unitPrice: goods.unitPrice || goods.price,
            shortName: goods.shortName,
            zeroTax: goods.zeroTax,
            taxPre: goods.taxPre,
            taxPreType: goods.taxPreType,
            splitCode: goods.splitCode,
            goodsTypeCode: goods.goodsTypeCode,
            revenueCode: goods.revenueCode,
            revenueVersion: goods.revenueVersion,
            taxRate: goods.taxRate,
            immediateLevyRefundCode: goods.immediateLevyRefundCode,
            amount: goods.amount || goods.amountWithTax,
            price: goods.price
          }
        })
      }
      return postData
    },

    addOrEditAddress () {
      return new Promise(async (resolve, reject) => {
        const merchantInfo = this.$store.state.invoice.merchantInfo
        const postData = {}

        const delEmptyParam = (data) => {
          for (let ele in data) {
            !data[ele] && typeof data[ele] !== 'number' && delete data[ele]
          }
          for (let key in data) {
            typeof data[key] === 'string' && !data[key].length && delete data[key]
          }
        }

        if (Number(this.detailData.logisticsFlag) === 1) {
          let addressData = {
            address: this.detailData.receiverAddress,
            userName: this.detailData.receiverName,
            telephone: this.detailData.receiverPhone,
            email: this.detailData.receiverEmail,
            id: this.detailData.receiverId,
            defaultFlag: 1,
            merchantId: (merchantInfo.id && merchantInfo.id.length) ? merchantInfo.id : ''
          }
          delEmptyParam(addressData)
          postData.addresseeInfoRequestList = [{
            ...addressData
          }]
        }

        postData.merchantArchivesVo = {
          id: merchantInfo.id,
          company: this.detailData.purchaserName,
          nature: merchantInfo.nature,
          taxNo: this.detailData.purchaserTaxNo,
          address: this.detailData.purchaserAddress,
          bankName: this.detailData.purchaserBankName,
          receiverEmail: this.detailData.receiverEmail,
          enable: 0
        }

        delEmptyParam(postData.merchantArchivesVo)

        await customerRequest.address.addOrEdit({
          ...postData
        })

        resolve(true)
      })
    },
    async saveApply () {
      this.$toast.loading()
      const postData = this.handleApplyData()
      let accessCodes = []
      let openConversationId = localStorage.get('openConversationId') || ''
      let count = postData.fileInfos ? postData.fileInfos.length + 5 : 5
      for (let i = 0; i < count; i++) {
        let code = await getDingCode()
        if (code) {
          accessCodes.push(code)
        }
      }
      const data = await invoiceRequest.apply.save({ ...postData, accessCodes, openConversationId, settlementSource: 12, applicant: this.userInfo.trueName, purchaserEmail: postData.receiverEmail })
      if (data.success) {
        this.$store.commit('user/changeRefreshStatistics', true)
        await this.addOrEditAddress()
        Notify({ type: 'success', message: '申请提交成功' })
        this.$store.commit('invoice/initApplyData')
        this.$store.commit('invoice/changeGoodsList', [])
        sessionStorage.clear()
        this.$router.push('/invoice/invoice-home')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async modifyApply () {
      const postData = this.handleApplyData()
      const data = await invoiceRequest.apply.edit({ ...postData, purchaserEmail: postData.purchaserEmail || postData.receiverEmail, applyReturnFlag: '0' })
      if (data.success) {
        await this.addOrEditAddress()
        Notify({ type: 'success', message: '申请编辑成功' })
        this.$store.commit('invoice/initApplyData')
        this.$store.commit('invoice/changeGoodsList', [])
        sessionStorage.clear()
        this.$router.push('/invoice/invoice-home')
      } else {
        Notify({ type: 'danger', message: data.message })
        this.$$router.go(-2)
      }
    },
    getConfig (item) {
      console.log(this.$store.state)
      let key = 'invoice-uninvoice'
      if (item.status === 0 || item.status === 1) {
        if (item.applyReturnFlag === 1) {
          key = 'invoice-return'
        } else {
          key = 'invoice-uninvoice' // 未开具
        }
      }
      if (item.status === 2) { // 开具中
        key = 'invoicing'
      }
      // if (item.status === 1) {
      //   key = 'invoice-part' // 部分开具
      // }
      if (item.status === 3) {
        key = 'invoice-success' // 开具成功
      }
      if (item.status === 4) {
        key = 'invoice-failed' // 开具失败
      }
      if (item.status === 6) {
        key = 'part' // 部分开具
      }
      if (item.invoiceStatus === 10 || item.invoiceStatus === 15 || item.invoiceStatus === 25) { // 正常   15红冲中 25作废中 属于 正常状态
        if (item.amount < 0) {
          key = 'output-negative' // 销项负数
        } else {
          key = 'invoice-normal'
        }
      }
      if (item.invoiceStatus === 10 && item.applyType === 1) {
        key = 'to-be-red' // 待红冲
      }
      if (item.invoiceStatus === 10 && item.applyType === 2) {
        key = 'to-be-cancel' // 待作废
      }
      if (item.invoiceStatus === 20) { // 红冲
        key = 'invoice-red'
      }
      if (item.invoiceStatus === 30) { // 作废
        key = 'invoice-abandon'
      }
      if (item.invoiceStatus === 40) { // 失控
        key = 'invoice-out-of-control'
      }
      if (item.invoiceStatus === 50) { // 异常
        key = 'invoice-error'
      }
      // 审核中
      if (item.approvalStatus === 0) {
        key = 'under-approval'
      }
      // 已驳回
      if (item.approvalStatus === 1) {
        key = 'returned'
      }
      // 已撤销
      if (item.approvalStatus === 3) {
        key = 'revoked'
      }
      // 审核通过
      if (!key) {
        if (item.approvalStatus === 2) {
          key = 'approved'
        } else {
          return ''
        }
      }
      return getConfigWithText(key, INVOICE_STATUS_ICON)
    }
  },
  beforeDestroy () {
    if (this.isClearData) {
      this.$store.commit('invoice/initApplyData')
      this.$store.commit('invoice/changeGoodsList', [])
    }
  },
  components: {
    ButtonRow,
    InvoiceDetail,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
